import React, { Fragment } from 'react';
import gql from 'graphql-tag';
import { connect } from 'react-redux';
import { Query } from 'react-apollo';
import CardFooter from './CardFooter';
import Table from './Table';

const USERS_QUERY = gql`
    query($operatorId: String!) {
        portalUsers(operatorId: $operatorId) {
            id,
            user {
                id, 
                name,
                email,
                phone,
                createdAt,
                lastLogin
            },
            isActive,
            permission
        }
    }
`;

const Card = ({ operatorId }) => (
    <div className="card shadow">
        <div className="card-header border-0">
            <h3 className="mb-0">Usuários</h3>
        </div>
        <Query query={USERS_QUERY} variables={{ operatorId }}>
            {({ loading, error, data }) => {
                if (loading) return 'Loading...';
                if (error) {
                    return (
                        <div className="rounded-0 alert alert-warning m-0">
                            Não foi possível carregar a lista de usuários.
                        </div>
                    );
                }
                const { portalUsers } = data;
                return (
                    <Fragment>
                        <Table users={portalUsers} />
                        <CardFooter />
                    </Fragment>
                );
            }}
        </Query>
    </div>
);

const mapStateToProps = (state) => ({
    operatorId: state.session.operatorId
});

export default connect(mapStateToProps)(Card);


// WEBPACK FOOTER //
// ./src/components/Pages/Users/Card.js